// Asset-Helper für einfachen Import und Pfad-Management

// Logos und Branding
import logo from '../assets/images/logo.webp';
import logo3DRender from '../assets/images/stimmdigital_3drender.webp';
import footerBgLogo from '../assets/images/footer-bglogo.webp';


// Social Media Icons
import facebook from '../assets/images/facebook.svg';
import instagram from '../assets/images/instagram.svg';
import telegram from '../assets/images/telegram.svg';
import twitter from '../assets/images/twitter.svg';


// Contact Icons
import contactTelegram from '../assets/images/contact/telegram.svg';
import contactWhatsapp from '../assets/images/contact/whatsapp.svg';



// Logos
import allsafe from '../assets/images/logos/allsafe.webp';
import channels42 from '../assets/images/logos/42channels.webp';
import mohrbach from '../assets/images/logos/mohrbach.webp';
import lernkarten from '../assets/images/logos/lernkarten.webp';
import m8werk from '../assets/images/logos/m8werk.webp';
import nextserve from '../assets/images/logos/nextserve.webp';
import osnalive from '../assets/images/logos/osnalive.webp';
import presseaugsburg from '../assets/images/logos/presseaugsburg.webp';
import serviceunion from '../assets/images/logos/serviceunion.webp';
import spoord from '../assets/images/logos/spoord.webp';

// Home Ref
import browser from '../assets/images/homeRef/browser.webp';
import browser1 from '../assets/images/homeRef/browser-1.webp';
import browser2 from '../assets/images/homeRef/browser-2.webp';
import browser3 from '../assets/images/homeRef/browser-3.webp';
import browser4 from '../assets/images/homeRef/browser-4.webp';
import browser5 from '../assets/images/homeRef/browser-5.webp';
import browser6 from '../assets/images/homeRef/browser-6.webp';
import browser7 from '../assets/images/homeRef/browser-7.webp';
import browser8 from '../assets/images/homeRef/browser-8.webp';
import browser9 from '../assets/images/homeRef/browser-9.webp';

export const ASSETS = {
  // Logos und Branding
  logo,
  logo3DRender,
  footerBgLogo,
  
  
  // Social Media Icons
  facebook,
  instagram,
  telegram,
  twitter,
  
  
  // Contact Icons
  contactTelegram,
  contactWhatsapp
  
} as const;

export const LOGO_ASSETS = {
  allsafe,
  channels42,
  mohrbach,
  lernkarten,
  m8werk,
  nextserve,
  osnalive,
  presseaugsburg,
  serviceunion,
  spoord,
} as const;

export const HOME_REF_ASSETS = {
  browser,
  browser1,
  browser2,
  browser3,
  browser4,
  browser5,
  browser6,
  browser7,
  browser8,
  browser9,
} as const;

// Hilfsfunktion für Asset-Pfade
export const getAssetPath = (assetName: keyof typeof ASSETS): string => {
  return ASSETS[assetName];
};

export const getLogoPath = (logoName: keyof typeof LOGO_ASSETS): string => {
  return LOGO_ASSETS[logoName];
};

export const getHomeRefPath = (refName: keyof typeof HOME_REF_ASSETS): string => {
  return HOME_REF_ASSETS[refName];
};

